import React from 'react'
import { connect } from 'react-redux'
import { valueExists, isOdd } from '../../misc/utils'
import { createComment, deleteComment } from '../../store/actions/comments'
import { updateIdeaStatus } from '../../store/actions/idea-status'
import { getIdea } from '../../store/actions/ideas'
import { likeComment, unlikeComment } from '../../store/actions/like-comment'
import { likeIdea, unlikeIdea } from '../../store/actions/like-idea'
import { STATUS_TYPE } from '../../store/api/status'
import CommentSection from '../common/comment-section'
import IdeaSummaryCard from '../common/idea-summary-card'
import Loading from '../common/loading'
import TextAreaSubmit from '../common/text-area-submit'
import { AttachmentSection } from '../common/attachment-section'
import { isUserModerator, createDisplayName } from '../../misc/auth-utils'
import { createFeedback, deleteFeedback } from '../../store/actions/feedback'
import moment from 'moment'
import IconButton from '../common/icon-button'
import { confirmationDialog } from '../common/confirmation-dialog'

export class IdeaView extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            ideaId: undefined,
            idea: undefined,
        }

        this.commentSection = React.createRef()
    }

    redirectToIdeaExplorerView = () => {
        this.props.history.push({
            pathname: '/explore',
            query: { test: 'hello' },
        })
    }

    componentDidMount() {
        if (!valueExists(this.props, 'selectedIdeaId')) {
            this.redirectToIdeaExplorerView()
        }
        this.props.getIdea(this.props.selectedIdeaId)
    }

    componentDidUpdate(prevProps) {
        if (prevProps.idea !== this.props.idea) {
            this.setState({
                idea: this.props.idea,
                comments: this.props.idea.comments,
                // reload: true,
            })
        }
    }

    onIdeaStatusChange = (value) => {
        this.props.updateIdeaStatus(
            STATUS_TYPE.IDEA,
            this.props.idea._id,
            value
        )
    }

    onLockStatusChange = (value) => {
        this.props.updateIdeaStatus(
            STATUS_TYPE.LOCK,
            this.props.idea._id,
            value
        )
    }

    onVisibilityStatusChange = (value) => {
        this.props.updateIdeaStatus(
            STATUS_TYPE.VISIBILITY,
            this.props.idea._id,
            value
        )
    }

    onLikeClick = () => {
        if (this.props.idea.liked_by_user)
            this.props.unlikeIdea(this.props.idea._id)
        else this.props.likeIdea(this.props.idea._id)
    }

    onCommentClick = () => {
        // TODO ASK SERVER TO CHANGE IT AND RELOAD IDEA
        window.scrollTo(0, this.commentSection.current.offsetTop)
        // this.insertCommentRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }

    onSubmitNewComment = (text) => {
        this.props.createComment(this.props.idea._id, text)
    }

    onSubmitFeedback = (text) => {
        confirmationDialog({
            title: 'Submit feedback',
            text:
                'Should this feedback be visible to all users (public) or only visible to the idea submitter (private)?',
            positiveText: 'Public',
            positiveColor: 'warning',
            negativeText: 'Private',
            negativeColor: 'primary',

            positiveCallback: () => {
                this.props.createFeedback(this.state.idea._id, text, true)
            },
            negativeCallback: () => {
                this.props.createFeedback(this.state.idea._id, text, false)
            },
        })
    }

    onDeleteFeedback = (idea_id, feedback_id) => {
        confirmationDialog({
            title: 'Remove feedback',
            text: 'Do you wish to remove the feedback?',
            positiveText: 'Remove',
            positiveColor: 'primary',
            negativeText: 'Cancel',
            negativeColor: 'secondary',

            positiveCallback: () => {
                this.props.deleteFeedback(idea_id, feedback_id)
            },
        })
    }

    render() {
        if (!this.state.idea) return <Loading />

        const renderFeedbackRow = (feedbackObj, index) => {
            const backgroundColor = isOdd(index)
                ? 'transparent'
                : 'var(--secondary-very-light)'
            const borderColor = isOdd(index)
                ? 'var(--secondary-very-light)'
                : 'var(--light-gray)'

            var submittedMoment = moment(feedbackObj.submitted_at)
            return (
                <div
                    key={feedbackObj._id}
                    className="row align-items-center justify-text-left comment-view"
                    style={{
                        backgroundColor: backgroundColor,
                        borderLeft: 'solid 2px',
                        borderLeftColor: borderColor,
                    }}>
                    {/* <div className="col-sm-1">
                        {feedbackObj.public ? 'Public' : 'Private'}
                    </div> */}
                    <div className="col-md-11 col-lg-6 mr-auto ">
                        <h6 className="mb-2">
                            {createDisplayName(feedbackObj.publisher)}{' '}
                            <small
                                rel="tooltip"
                                title={submittedMoment.format('LLLL')}>
                                wrote {submittedMoment.fromNow()}.
                            </small>
                        </h6>
                        <p>{feedbackObj.text}</p>
                    </div>

                    {isUserModerator(this.props.auth.user) && (
                        <div className="col-sm-1 text-secondary">
                            <IconButton
                                icon="trash"
                                onClick={() =>
                                    this.onDeleteFeedback(
                                        this.state.idea._id,
                                        feedbackObj._id
                                    )
                                }
                            />
                        </div>
                    )}
                </div>
            )
        }

        const renderFeedbackSection = () => {
            const canViewPrivateFeedback =
                isUserModerator(this.props.auth.user) ||
                this.props.auth.user._id === this.state.idea.publisher._id

            const canAddFeedback = isUserModerator(this.props.auth.user)

            const hasPublicFeedback =
                this.state.idea.feedback &&
                this.state.idea.feedback.filter((f) => f.public === true)
                    .length > 0

            const hasPrivateFeedback =
                this.state.idea.feedback &&
                this.state.idea.feedback.filter((f) => f.public === false)
                    .length > 0

            // Render public feedback
            const renderPublicFeedback = () => {
                return (
                    <div>
                        {this.state.idea.feedback &&
                            this.state.idea.feedback
                                .filter((f) => f.public === true)
                                .map((f, ix) => renderFeedbackRow(f, ix))}
                    </div>
                )
            }

            // Render private feedback
            const renderPrivateFeedback = () => {
                return (
                    <div>
                        {this.state.idea.feedback &&
                            this.state.idea.feedback
                                .filter((f) => f.public === false)
                                .map((f, ix) => renderFeedbackRow(f, ix))}
                    </div>
                )
            }

            // Render inputs
            const renderInputs = () => {
                return (
                    <div className="mt-2">
                        {/* <p className="mt-4">
                            <small>Add feedback:</small>
                        </p> */}
                        <TextAreaSubmit
                            text=""
                            maxLength="500"
                            clearOnSubmit={true}
                            rows="4"
                            onSubmit={this.onSubmitFeedback}
                            placeholder="Add feedback..."></TextAreaSubmit>
                    </div>
                )
            }

            if (canViewPrivateFeedback) {
                return (
                    <div className="container">
                        <p className="text-secondary">Private:</p>

                        {!hasPrivateFeedback && (
                            <p className="text-secondary">
                                <small>No private feedback received</small>
                            </p>
                        )}

                        {renderPrivateFeedback()}

                        <div className="border-top my-3 mt-4" />

                        <p className="text-secondary">Public:</p>
                        {!hasPublicFeedback && (
                            <p className="text-secondary">
                                <small>No public feedback received</small>
                            </p>
                        )}

                        {renderPublicFeedback()}

                        {canAddFeedback && (
                            <div className="border-top my-3 mt-4" />
                        )}

                        {canAddFeedback && renderInputs()}
                    </div>
                )
            } else {
                return (
                    <div className="container">
                        {!hasPublicFeedback && (
                            <p className="text-secondary">
                                Waiting for feedback!
                            </p>
                        )}
                        {renderPublicFeedback()}
                    </div>
                )
            }
        }

        const descriptionNumRows = (text) => {
            if (!text) return 5

            const numRows = text.split(' ').length / 30

            if (numRows < 8) return 8
            if (numRows > 20) return 20
        }

        return (
            <>
                {this.state.idea.visibility_status === 'hidden' && (
                    <p className="text-warning text-center mb-4">
                        This Idea is still pending approval and is not yet
                        visible to other members.
                    </p>
                )}

                <IdeaSummaryCard
                    idea={this.state.idea}
                    onIdeaStatusChange={this.onIdeaStatusChange}
                    onLockStatusChange={this.onLockStatusChange}
                    onVisibilityStatusChange={this.onVisibilityStatusChange}
                    onLikeClick={this.onLikeClick}
                    onCommentClick={this.onCommentClick}
                    redirectMode={false}
                />

                <div className="border-top my-3 mt-4" />

                <p className="font-weight-bold text-secondary mt-4">
                    Description
                </p>
                <div className="row mt-3">
                    <div className="col-sm">
                        <textarea
                            className="form-control read-only-text-area"
                            rows={descriptionNumRows(
                                this.state.idea.description
                            )}
                            disabled={true}
                            defaultValue={
                                this.state.idea.description
                            }></textarea>
                    </div>
                </div>

                <div className="border-top my-3 mt-4" />

                {this.state.idea.attachments &&
                    this.state.idea.attachments.length > 0 && (
                        <>
                            <p className="font-weight-bold text-secondary mt-4">
                                Attachments
                            </p>
                            <AttachmentSection
                                attachments={this.state.idea.attachments}
                                editMode={false}
                            />
                        </>
                    )}

                {/* <p className="font-weight-bold text-secondary mt-4">Feedback</p> */}

                <div className="" id="feedbackCollapse">
                    <div className="card">
                        <div className="card-header" id="headingOne">
                            <h5 className="mb-0">
                                <button
                                    className="btn btn-link font-weight-bold text-secondary"
                                    type="button"
                                    data-toggle="collapse"
                                    data-target="#collapseOne"
                                    aria-expanded="false"
                                    aria-controls="collapseOne">
                                    Feedback
                                </button>
                            </h5>
                        </div>

                        <div
                            id="collapseOne"
                            className="collapse hide"
                            aria-labelledby="headingOne"
                            data-parent="#feedbackCollapse">
                            <div class="card-body">
                                {renderFeedbackSection()}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="border-top my-2 mt-2" />

                <p
                    className="font-weight-bold text-secondary mt-4"
                    ref={this.commentSection}>
                    Discussion
                </p>

                <TextAreaSubmit
                    text=""
                    maxLength="500"
                    rows="2"
                    clearOnSubmit={true}
                    onSubmit={this.onSubmitNewComment}
                    placeholder="Add a comment..."></TextAreaSubmit>

                {this.state.comments && (
                    <CommentSection
                        idea_id={this.props.idea._id}
                        comments={this.state.comments}
                    />
                )}
            </>
        )
    }
}

const mapStateToProps = (state) => ({
    auth: state.auth,
    selectedIdeaId: state.ideas.selectedIdeaId,
    idea: state.ideas.idea,
})

export default connect(mapStateToProps, {
    getIdea,
    updateIdeaStatus,
    createComment,
    deleteComment,
    likeComment,
    unlikeComment,
    likeIdea,
    unlikeIdea,
    createFeedback,
    deleteFeedback,
})(IdeaView)
